export function EOMonth(date, months = 0) {
  const newDate = new Date(date);
  newDate.setMonth(newDate.getMonth() + months + 1, 0);
  return newDate;
}
